// A tour's dismissal, kept on this device from the moment it is given. The
// UpdateUser call dies with the page if the person leaves at once; what is kept
// here hides the tour all the same, and is sent again on the next load until the
// server has it. Kept per user, so one person's record never hides another's tour.
//
// Never cleared: the cached profile is patched as soon as a tour is dismissed, so
// it cannot show that the server has the dismissal. A fresh load's profile can,
// and then nothing is sent. Readers build a set, so an id sent twice is harmless.

function getStorageKey(userId: string) {
  return `kudu.productTours.dismissed:${userId}`;
}

export function readDeviceDismissals(userId: string | null): string[] {
  if (!userId) {
    return [];
  }

  try {
    const stored: unknown = JSON.parse(
      window.localStorage.getItem(getStorageKey(userId)) ?? '[]',
    );

    return Array.isArray(stored)
      ? stored.filter((tourId): tourId is string => typeof tourId === 'string')
      : [];
  } catch {
    // Storage refused, or holding something else: the server's list still counts.
    return [];
  }
}

export function recordDeviceDismissal(userId: string, tourId: string) {
  const tourIds = readDeviceDismissals(userId);

  if (tourIds.includes(tourId)) {
    return;
  }

  try {
    window.localStorage.setItem(
      getStorageKey(userId),
      JSON.stringify([...tourIds, tourId]),
    );
  } catch {
    // The tour closes all the same, and the server may still get the call.
  }
}
